import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ContactFormData, NewsletterSubscription} from "../models/model";

@Injectable({
  providedIn: 'root'
})
export class ExternService {
    //private baseUrl = 'http://localhost:8080/api/extern'; // Change selon ton serveur
    private baseUrl = 'https://sgl-demo-api.geekinstitut.com/api/extern'

    constructor(private http: HttpClient) {}

    sendContactForm(data: ContactFormData): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/contact-tommys-fs`, data);
    }

    subscribeNewsletter(data: NewsletterSubscription): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/newsletter-tommys-fs`, data);
    }
}
